import React from 'react';

/**
 * Tarjetas horizontales de métricas y telemetría en tiempo real para la dinámica "Arma la Playlist" (Tile ID 46).
 * Muestra 6 KPIs clave en carril horizontal con scrollbar: Total Sugerencias, En Playlist, Reproducidas, Agregadas por Operador, Aficionados Participantes y Canción Más Pedida.
 * 
 * @component PlaylistMetricsCards
 * @param {Object} props
 * @param {Object} [props.metrics] - Objeto de métricas proveniente del backend / WebSocket.
 * @param {number} [props.metrics.totalSuggestions=0]
 * @param {number} [props.metrics.activeInPlaylist=0]
 * @param {number} [props.metrics.totalPlayed=0]
 * @param {number} [props.metrics.totalOperatorAdded=0]
 * @param {number} [props.metrics.uniqueFans=0]
 * @param {string} [props.metrics.topRequestedSongTitle='']
 * @param {number} [props.metrics.topRequestedSongVotes=0]
 */
export const PlaylistMetricsCards = ({ metrics = {} }) => {
    const totalSuggestions = metrics.totalSuggestions ?? 0;
    const activeInPlaylist = metrics.activeInPlaylist ?? 0;
    const totalPlayed = metrics.totalPlayed ?? 0;
    const totalOperatorAdded = metrics.totalOperatorAdded ?? 0;
    const uniqueFans = metrics.uniqueFans ?? 0;
    const topRequestedSongTitle = metrics.topRequestedSongTitle || '';
    const topRequestedSongVotes = metrics.topRequestedSongVotes ?? 0;

    return (
        <section className="PlaylistMetricsCards" aria-label="Métricas de la dinámica en tiempo real">
            <div className="PlaylistMetricsCards__Grid">
                {/* 1. Total Sugerencias */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--suggestions">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-inbox-fill"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">Total Sugerencias</span>
                        <span className="PlaylistMetricsCards__Value">{totalSuggestions}</span>
                        <span className="PlaylistMetricsCards__Subtext">Recibidas en cabina</span>
                    </div>
                </div>

                {/* 2. En Playlist Activa */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--active">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-star-fill"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">En Playlist</span>
                        <span className="PlaylistMetricsCards__Value">{activeInPlaylist}</span>
                        <span className="PlaylistMetricsCards__Subtext">En lista de estadio</span>
                    </div>
                </div>

                {/* 3. Reproducidas */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--played">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-check-circle-fill"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">Reproducidas</span>
                        <span className="PlaylistMetricsCards__Value">{totalPlayed}</span>
                        <span className="PlaylistMetricsCards__Subtext">Sonaron en el partido</span>
                    </div>
                </div>

                {/* 4. Agregadas por Operador */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--operator">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-headphones"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">Por Operador</span>
                        <span className="PlaylistMetricsCards__Value">{totalOperatorAdded}</span>
                        <span className="PlaylistMetricsCards__Subtext">Añadidas por cabina DJ</span>
                    </div>
                </div>

                {/* 5. Aficionados Participantes */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--fans">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-people-fill"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">Aficionados</span>
                        <span className="PlaylistMetricsCards__Value">{uniqueFans}</span>
                        <span className="PlaylistMetricsCards__Subtext">Participantes únicos</span>
                    </div>
                </div>

                {/* 6. Canción Más Pedida */}
                <div className="PlaylistMetricsCards__Card PlaylistMetricsCards__Card--top">
                    <div className="PlaylistMetricsCards__IconWrapper">
                        <i className="bi bi-fire"></i>
                    </div>
                    <div className="PlaylistMetricsCards__Info">
                        <span className="PlaylistMetricsCards__Label">Más Pedida</span>
                        <span 
                            className="PlaylistMetricsCards__Value PlaylistMetricsCards__Value--title text-truncate" 
                            title={topRequestedSongTitle ? `${topRequestedSongTitle} (${topRequestedSongVotes} votos)` : 'Sin votos'}
                        >
                            {topRequestedSongTitle ? topRequestedSongTitle : 'N/A'}
                        </span>
                        <span className="PlaylistMetricsCards__Subtext">
                            {topRequestedSongTitle
                                ? `🔥 ${topRequestedSongVotes} ${topRequestedSongVotes === 1 ? 'voto' : 'votos'}`
                                : 'A la espera de votos'}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PlaylistMetricsCards;
